import { render, staticRenderFns } from "./fengrengongziDetail.vue?vue&type=template&id=db1bb560&scoped=true&"
import script from "./fengrengongziDetail.vue?vue&type=script&lang=js&"
export * from "./fengrengongziDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db1bb560",
  null
  
)

export default component.exports